import { RaviWidget } from '@/modules/rate-and-review';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useMemo } from 'react';

export const FragmentRateReview = ({ profileData }: { profileData: any }) => {
  const dontShowRateDetails = useFeatureIsOn('ravi_show_external_rate');

  const centers = useMemo(
    () =>
      (profileData?.centers ?? [])
        .filter((center: { id?: unknown; name?: string }) => center?.id && center?.name)
        .map((center: { id: unknown; name: string }) => ({
          id: String(center.id),
          name: center.name,
        })),
    [profileData?.centers],
  );

  // The doctor's P24 user id (numeric) — not information.id, which is the doctor_id uuid. Reviews,
  // replies, /v1/users and the logged-in user all use the numeric user id (same as pages/dr/[slug]).
  const doctorUserId = profileData?.information?.user_id ?? profileData?.user_id;

  return (
    <div className="flex flex-col space-y-1">
      <RaviWidget
        doctorSlug={profileData.seo.slug}
        doctorUserId={doctorUserId != null && doctorUserId !== '' ? String(doctorUserId) : undefined}
        displayName={profileData?.information?.display_name}
        centers={centers}
        hideSummary={dontShowRateDetails}
      />
    </div>
  );
};
